module.exports = __webpack_public_path__ + "img/1025.4a206a31.png";